import { Api } from './api.js';
import { attachChat } from './chat.js';
import { loadConfig } from './config.js';
import { h } from './dom.js';
import { showLogin } from './login.js';
import { showPicker } from './picker.js';
import { attachPublish } from './publish.js';
import { openWorkspace } from './workspace.js';

const app = document.getElementById('app');

async function signedIn(api) {
  try {
    await api.creations({ limit: 1 });
    return true;
  } catch (err) {
    if (err.status === 401) return false;
    throw err;
  }
}

function fatal(err) {
  app.replaceChildren(h('div.fatal', `Failed to start: ${err.message ?? err}`));
}

async function start() {
  const config = await loadConfig();
  let expired = false;
  const api = new Api(config.apiBase, {
    // The cookie expired mid-session: back to the login screen, then reload into the same URL.
    onUnauthenticated: () => {
      if (expired) return;
      expired = true;
      showLogin(app, api, { message: 'Your session expired. Sign in again.' }).then(() => location.reload());
    },
  });
  if (!(await signedIn(api))) await showLogin(app, api);

  const logout = h('button.logout', {
    type: 'button',
    onclick: async () => {
      await api.logout().catch(() => {});
      location.href = location.pathname;
    },
  }, 'Sign out');
  const main = h('main.main');
  app.replaceChildren(main, logout);

  const creationId = new URLSearchParams(location.search).get('creation');
  if (!creationId) {
    await showPicker(main, api, (id) => { location.search = `?creation=${id}`; });
    return;
  }
  const workspace = await openWorkspace(main, api, creationId);
  if (import.meta.env.DEV) window.cpWeb = workspace; // for poking at it from the console
  attachChat(workspace);
  attachPublish(workspace);
}

start().catch(fatal);
